export const ArrowBackWhiteIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.44727 7.85358C2.25211 7.65836 2.25216 7.3418 2.44727 7.14655L6.30078 3.29303L7.00781 4.00006L4.00781 7.00006L11.7012 7.00006L11.7012 8.00006L4.00781 8.00006L7.00781 11.0001L6.30078 11.7071L2.44727 7.85358Z"
      fill="currentColor"
    />
  </svg>
);
